import Temp from '@/courier/Temp'

export default class GenCourier extends Temp {

    static CODE = 'GEN';

    constructor() {
        super( GenCourier.CODE ); 
    }

    getZone( item ){
        let type
        let cross_price = 0
        let remote_area = 0

        type = super.checkZone( item.toPostcode );

        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }

    checkWeight( courierRates , item  ){
        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })
        
        return {
            index: item.index
        } 
    }

}